import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AccountVoidedFilterWrapper = styled.div`
  margin-right: ${Spacing.S16};
  margin-left: auto;
`
